import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5647152e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=5647152e&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=5647152e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647152e",
  null
  
)

export default component.exports